var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import moment from "moment";
import { clone } from "../../../../../Shared/utils/clone";
import { ActionTypes } from "../../../../OrderFlowProvider/OrderFlowActionTypes";
import { decrementRecipe_V2 } from "./decrementRecipe_V2";
/**
 * Decrement the quantity of a recipe assignment for a meal. Immediately dispatches and updates the store.
 *
 * @param enableAssignRecipes
 * @param enableRemoveMeals
 * @param onlyShowDeliveryDays
 * @param template
 * @param cartMeals
 * @param daysOfWeek
 * @param sku
 * @param companyUsesKlaviyo
 * @param selectedDay
 * @param dispatch
 * @param createKlaviyoEvent
 * @param logReactPixel
 * @param assignmentId
 * @param reactPixelKey
 * @returns
 */
export const handleRecipeDecrement_V2 = ({ enableAssignRecipes, enableRemoveMeals, onlyShowDeliveryDays, template, cartMeals, daysOfWeek, sku, companyUsesKlaviyo, selectedDay, dispatch, createKlaviyoEvent, logReactPixel, assignmentId, reactPixelKey, recipe, programMealId, }) => __awaiter(void 0, void 0, void 0, function* () {
    const clonedMeals = clone(cartMeals);
    const { meals, mealPrice, mealName, mealDate } = yield decrementRecipe_V2({
        enableAssignRecipes,
        enableRemoveMeals,
        onlyShowDeliveryDays,
        template,
        clonedMeals,
        daysOfWeek,
        selectedDay: selectedDay,
        recipe,
        programMealId,
        assignmentId,
    });
    if (companyUsesKlaviyo) {
        let totalQuantity = 0;
        const mealsForKlaviyo = meals.filter((meal) => moment(meal.MealDate).isSame(moment(mealDate)) && meal.ProgramMealId === programMealId && meal.RecipeAssignments);
        mealsForKlaviyo.forEach((meal) => {
            var _a, _b, _c;
            totalQuantity +=
                (_c = (_b = (_a = meal === null || meal === void 0 ? void 0 : meal.RecipeAssignments) === null || _a === void 0 ? void 0 : _a.filter((ra) => ra.RecipeId === recipe.RecipeId)) === null || _b === void 0 ? void 0 : _b.reduce((accum, ra) => accum + ra.Quantity, 0)) !== null && _c !== void 0 ? _c : 0;
        });
        const eventInfo = {
            RecipeName: recipe.RecipeName,
            Quantity: totalQuantity,
            MealName: mealName,
            SKU: sku,
            DayOfWeek: moment(recipe.AvailableOn).format("ddd"),
        };
        createKlaviyoEvent("Removed Recipe", eventInfo);
    }
    if (reactPixelKey) {
        const data = {
            content_name: recipe.RecipeName,
            content_ids: recipe.RecipeId,
            content_type: "meal",
            value: mealPrice,
            currency: "USD",
        };
        logReactPixel("RemoveMeal", data);
    }
    dispatch({ type: ActionTypes.SET_MEALS, payload: meals });
});
